import React, { useState } from 'react';
import { X, MessageCircle, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
interface PostWorkoutFeedbackSheetProps {
  onSubmit: (feedback: string) => void;
  onSkip: () => void;
  onClose: () => void;
  preselectedOption?: string;
  showSuccess?: boolean;
}
export function PostWorkoutFeedbackSheet({
  onSubmit,
  onSkip,
  onClose,
  preselectedOption,
  showSuccess = false
}: PostWorkoutFeedbackSheetProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(preselectedOption || null);
  const [isSuccess, setIsSuccess] = useState(showSuccess);
  const options = [{
    value: 'easy',
    label: 'Easy'
  }, {
    value: 'moderate',
    label: 'Moderate'
  }, {
    value: 'hard',
    label: 'Hard'
  }, {
    value: 'very_hard',
    label: 'Very hard'
  }];
  const handleSubmit = () => {
    if (selectedOption) {
      onSubmit(selectedOption);
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
      }, 1500);
    }
  };
  if (isSuccess) {
    return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-end animate-in fade-in duration-200" onClick={onClose} data-id="element-253">
        <div className="bg-white w-full rounded-t-[2.5rem] p-6 pb-8 shadow-2xl animate-in slide-in-from-bottom-full duration-300 relative" onClick={e => e.stopPropagation()} data-id="element-254">
          <button onClick={onClose} className="absolute top-5 right-5 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-255">
            <X size={20} data-id="element-256" />
          </button>
          <div className="flex flex-col items-center justify-center py-8" data-id="element-257">
            <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4" data-id="element-258">
              <CheckCircle2 size={32} data-id="element-259" />
            </div>
            <h2 className="text-xl font-extrabold text-slate-800 mb-2" data-id="element-260">
              Thank you
            </h2>
            <p className="text-sm font-medium text-slate-500 text-center" data-id="element-261">
              Your feedback has been saved.
            </p>
          </div>
        </div>
      </div>;
  }
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-end animate-in fade-in duration-200" data-id="element-262">
      <div className="bg-white w-full rounded-t-[2.5rem] p-6 pb-8 shadow-2xl animate-in slide-in-from-bottom-full duration-300" data-id="element-263">
        <div className="flex items-center justify-between mb-6" data-id="element-264">
          <div className="flex items-center gap-3" data-id="element-265">
            <div className="w-10 h-10 bg-blue-50 text-blue-500 rounded-full flex items-center justify-center" data-id="element-266">
              <MessageCircle size={20} data-id="element-267" />
            </div>
            <h2 className="text-xl font-extrabold text-slate-800" data-id="element-268">
              How did this workout feel?
            </h2>
          </div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-269">
            <X size={24} data-id="element-270" />
          </button>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4 mb-6 border border-slate-100 flex items-center gap-4" data-id="element-271">
          <div className="w-12 h-12 rounded-2xl overflow-hidden border-2 border-white shadow-sm bg-stone-200 shrink-0" data-id="element-272">
            <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="Post-Workout Difficulty Feedback form1.mp4" data-id="element-273" />
          </div>
          <div data-id="element-274">
            <h3 className="font-extrabold text-slate-800 text-sm mb-0.5" data-id="element-275">
              Full Body
            </h3>
            <p className="text-xs font-medium text-slate-500" data-id="element-276">
              Completed on Wednesday, 25 March
            </p>
          </div>
        </div>

        <p className="text-sm font-medium text-slate-500 mb-6 leading-relaxed" data-id="element-277">
          Your feedback helps us adjust future workouts.
        </p>

        <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-278">
          {options.map(option => <button key={option.value} onClick={() => setSelectedOption(option.value)} className={`
                py-4 px-4 rounded-2xl font-bold text-center transition-all duration-200
                border-2
                ${selectedOption === option.value ? 'bg-emerald-50/50 border-emerald-500 text-emerald-700 shadow-sm scale-105' : 'bg-white border-slate-100 text-slate-700 hover:border-slate-200 hover:bg-slate-50'}
              `} data-id="element-279">
              {option.label}
            </button>)}
        </div>

        <div className="space-y-3" data-id="element-280">
          <Button variant="primary" fullWidth onClick={handleSubmit} disabled={!selectedOption} data-id="element-281">
            Submit
          </Button>
          <button onClick={onSkip} className="w-full text-sm font-bold text-slate-500 hover:text-slate-700 transition-colors py-2" data-id="element-282">
            Skip for now
          </button>
        </div>
      </div>
    </div>;
}